module.exports = __webpack_public_path__ + "assets/img/close-zoom.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/close-zoom.png
// module id = 1935
// module chunks = 0